import {
    ALLOWED_TYPES_SENTENCE,
    MAX_ATTACHMENT_BYTES,
    MAX_ATTACHMENT_SIZE_LABEL,
    findAttachmentRule,
    findAttachmentRuleByExtension,
    formatFileSize,
    normalizeMimeType,
    type AttachmentTypeRule
} from './attachmentRules.ts';

export interface AttachmentCandidate {
    name: string;
    type: string;
    size: number;
}

export type AttachmentValidation = { ok: true; mimeType: string } | { ok: false; error: string };

function fileExtension(name: string): string | null {
    const dot = name.lastIndexOf('.');
    if (dot <= 0 || dot === name.length - 1) return null;
    return name.slice(dot + 1).toLowerCase();
}

function ruleFor(type: string, extension: string | null): AttachmentTypeRule | undefined {
    if (normalizeMimeType(type)) return findAttachmentRule(type);
    return extension ? findAttachmentRuleByExtension(extension) : undefined;
}

export function validateAttachment({
    name,
    type,
    size
}: AttachmentCandidate): AttachmentValidation {
    const extension = fileExtension(name);
    const rule = ruleFor(type, extension);
    if (!rule) {
        return { ok: false, error: `"${name}" can't be sent. Attach ${ALLOWED_TYPES_SENTENCE}.` };
    }
    if (extension && !rule.extensions.includes(extension)) {
        return {
            ok: false,
            error: `"${name}" is reported as a ${rule.label} file but its name says .${extension}, so it can't be sent.`
        };
    }
    if (size <= 0) {
        return { ok: false, error: `"${name}" is empty.` };
    }
    if (size > MAX_ATTACHMENT_BYTES) {
        return {
            ok: false,
            error: `"${name}" is ${formatFileSize(size)}. Attachments can be up to ${MAX_ATTACHMENT_SIZE_LABEL}.`
        };
    }
    return { ok: true, mimeType: rule.mimeType };
}
